import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { api } from "../lib/api";
import { t } from "../i18n";

// Shown only while a pack offer runs (dates come from the server), aimed at parents
export const OfferBanner = () => {
  const [pack, setPack] = useState(null);
  useEffect(() => {
    api.get("/packs").then((r) => setPack(r.data.find((p) => p.offer && Date.now() <= Date.parse(p.offer.ends_at)) || null)).catch(() => {});
  }, []);
  if (!pack) return null;

  return (
    <Link to="/espace-parents" data-testid="home-offer-banner"
      className="mb-6 flex items-center gap-3 rounded-[28px] border-4 border-white bg-[#F0303A] px-4 py-3 text-white shadow-[0_6px_0_rgba(0,0,0,0.15)] transition-transform duration-150 hover:-translate-y-0.5 anim-pop">
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-white/20"><Gift className="h-7 w-7" strokeWidth={2.5} /></span>
      <span className="min-w-0 flex-1 leading-tight">
        <span className="block text-xs font-bold uppercase tracking-wide opacity-90">{t("offer.forParents")}</span>
        <span className="block font-display text-base sm:text-lg font-extrabold" data-testid="home-offer-banner-text">{t("offer.banner")}</span>
        <span className="block text-sm opacity-90" data-testid="home-offer-banner-note">{pack.offer.note}</span>
      </span>
    </Link>
  );
};
